import { render, staticRenderFns } from "./singpass-callback.vue?vue&type=template&id=4b8f1bd2&scoped=true"
import script from "./singpass-callback.vue?vue&type=script&lang=js"
export * from "./singpass-callback.vue?vue&type=script&lang=js"
import style0 from "./singpass-callback.vue?vue&type=style&index=0&id=4b8f1bd2&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./singpass-callback.vue?vue&type=style&index=1&id=4b8f1bd2&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f1bd2",
  null
  
)

export default component.exports